module.exports = __webpack_public_path__ + "img/196.480396a4.jpg";